import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import "./EducationPage.css";

const EducationPage = () => {
  return (
    <div className="education-container">
      <div className="education-header">
        <p>experience</p>
        <p>
          <span>&</span>education
        </p>
      </div>
      <div className="education-list">
        {/*
        <div className="education">
          <p>Software Developer</p>
          <p>Siemens Healthcare</p>
          <p>
            <span>Sept'19 - Present</span>
            <a href="/">
              <LocationOnIcon />
              Bangalore, India
            </a>
          </p>
        </div>

        */}
        
        <div className="education">
          <p>Masters of Computer Application</p>
          <p>Lovely Professional University</p>
          <p>
            <span>Aug'25 - 27</span>
            <a href="https://maps.app.goo.gl/tN1bpqtFbRW8EcNh9">
              <LocationOnIcon />
              Phagwara - Punjab , India
            </a>
          </p>
        </div>


        <div className="education">
          <p>Bachelors of Computer Application</p>
          <p>M. S. I. T. M. Degree College</p>
          <p>
            <span>July'22 - June'25</span>
            <a href="https://maps.app.goo.gl/xrF1hMZCrAFzeH4K9">
              <LocationOnIcon />
              Gonda, India
            </a>
          </p>
        </div>
        <div className="education">
          <p>Higher Secondary Education</p>
          <p>Bal Vidya Mandir Inter College</p>
          <p>
            <span>April'20 - March'22</span>
            <a href="https://maps.app.goo.gl/xD2QUx7HiFq7znGa7">
              <LocationOnIcon />
              Gonda, India
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EducationPage;
